import { getSelector } from './get-selector';

let lastLcpEntryElement: LargestContentfulPaint['element'];

export const getExtraLcpContext = () => ({
  lcpElementSelector: getSelector(lastLcpEntryElement),
});

export const init = () => {
  lastLcpEntryElement = null;

  const lcpObserver = new PerformanceObserver(list => {
    list.getEntries().forEach(entry => {
      lastLcpEntryElement = (<LargestContentfulPaint>entry).element;
    });
  });
  lcpObserver.observe({
    type: 'largest-contentful-paint',
    buffered: true,
  });
};
